import React, {Component} from 'react';
import {Button, Modal, Grid, Form, Message} from 'semantic-ui-react';
import moment from "moment";
import connect from "react-redux/es/connect/connect";
import DayPickerInput from "react-day-picker/DayPickerInput";

import {showToast} from "../../actions/ToastAction";
import {ticketEditModal} from "../../actions/TicketEditDialog";
import ClientOrder from "../sale/ClientOrder";
import SaleData from "../../data/SaleData";
import {dynamicTableAddOrUpdate} from "../../actions/DynamicTableDataAction";
import QuestionDialog from "../extras/QuestionDialog";
import TicketData from "../../data/TicketData";

class TicketEditDialog extends Component {

    constructor() {
        super();

        this.state = {
            ticket:null,
            sending: false,
            sending_cancel: false
        };
    }

    handleClose = () => {
        this.props.ticketEditModal({
            open: false,
            ticket:{
                code: null,
                sale: {
                    client: null,
                    state: null
                },
                ticket: {
                    has_expiration: false
                },
                is_active: false
            }
        });
    };

    handleCancelSale = () => {
        this.refs.deleteDialog.open('', this.props.dialog.ticket.sale.id);
    };

    delete = (id) => {
        this.setState({sending_cancel:true});
        SaleData.cancel({id}, res =>{
            if(res && res.update){
                let ticket =  Object.assign({}, this.props.dialog.ticket);
                ticket.sale.state = 2;
                this.props.ticketEditModal({open:true, ticket});
                this.props.dynamicTableAddOrUpdate(ticket);
                this.props.showToast({open:true, message:'Venta Anulada', type:'success'});
            }else{
                this.props.showToast({open:true, message:'Tenemos un problema', type:'error'});
            }
            this.setState({sending_cancel:false});
        });
    };

    handleActive = () => {
        let ticket =  Object.assign({}, this.props.dialog.ticket);
        ticket.is_active = !ticket.is_active;
        let data = {
            id:ticket.id,
            is_active: ticket.is_active,
            end_date: ticket.end_date
        };
        this.update(data, ticket);
    };

    handleEndDateChange = (selectedDay) => {
        let date = moment(selectedDay).format("YYYY-MM-DD");
        let ticket =  Object.assign({}, this.props.dialog.ticket);
        ticket.end_date = date;
        let data = {
            id:ticket.id,
            is_active: ticket.is_active,
            end_date: ticket.end_date
        };
        this.update(data, ticket);
    };

    update = (data, ticket) => {
        this.props.ticketEditModal({open:true, ticket});
        this.props.dynamicTableAddOrUpdate(ticket);

        TicketData.updateClient(data, res => {
            if(res && res.update){
                this.props.showToast({open:true, message:'Tiquetera Actualizada', type:'success'});
            }else{
                this.props.showToast({open:true, message:'Tenemos un problema', type:'error'});
            }
        });
    };

    render() {
        return (
            <div>
                <Modal size='small' dimmer='inverted' open={this.props.dialog.open} onClose={this.handleClose}>
                    <Modal.Header>Tiquetera Nº {this.props.dialog.ticket.code}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form>
                                <Grid stackable>
                                    <Grid.Row>
                                        <Grid.Column width={8}>
                                            <ClientOrder
                                                client={this.props.dialog.ticket.sale.client}
                                                index={0}
                                                sale={this.props.dialog.ticket.sale.id}
                                                ref='client'
                                                saving={false}
                                                can_delete={false}
                                            />
                                            <br/>
                                            <Form.Checkbox
                                                label={`Estado ${this.props.dialog.ticket.is_active ? 'Activa':'Inactiva'}`}
                                                checked={this.props.dialog.ticket.is_active}
                                                onChange={this.handleActive}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            <label>Fecha de Caducidad</label>
                                            {this.props.dialog.ticket.ticket.has_expiration ? <DayPickerInput placeholder="MM/DD/YYYY" format="MM/DD/YYYY" value={this.props.dialog.ticket.end_date} onDayChange={this.handleEndDateChange}/>:<p><strong>No Caduca</strong></p>}
                                            <br/>
                                            {this.props.dialog.ticket.sale.state ===2 ? <Message><Message.Header>Venta Anulada</Message.Header></Message>:<Button fluid disabled={this.state.sending_cancel} loading={this.state.sending_cancel} onClick={this.handleCancelSale} content='Anular Venta'/>}
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
                <QuestionDialog ref="deleteDialog" message="Anular esta venta" callbackConfirm={this.delete}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        dialog: state.get('ticket_edit_dialog'),
        select_client: state.get('select_client'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        ticketEditModal(data) {
            dispatch(ticketEditModal(data));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TicketEditDialog);


// WEBPACK FOOTER //
// ./src/components/services/TicketEditDialog.js